import { DecompositionTreeNode } from "#decomposition-tree-node";
import {
  BottomSheet,
  type BottomSheetHandle,
} from "@-/dev.improve.haniverse.components.ui.bottom-sheet";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { GraphemeMorphemePanelsContext } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { type Ref, useCallback, useImperativeHandle, useRef } from "react";
import { View } from "@-/com.npmjs.react-native";

export interface DecompositionTreeSheetHandle {
  close: () => void;
  open: () => void;
}

export function DecompositionTreeSheet({ ref }: { ref?: Ref<DecompositionTreeSheetHandle> }) {
  const [readonlySlice] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data,
  );
  const bottomSheetRef = useRef<BottomSheetHandle>(null);

  useImperativeHandle(
    ref,
    () => ({
      close: () => {
        bottomSheetRef.current?.close();
      },
      open: () => {
        bottomSheetRef.current?.open();
      },
    }),
    [],
  );

  const handleSelect = useCallback(() => {
    bottomSheetRef.current?.close();
  }, []);

  return (
    <BottomSheet enableContentPanningGesture={false} fullHeight ref={bottomSheetRef}>
      <View className="flex-1">
        <View className="items-center gap-1 pt-1 pb-4">
          <Text
            accessibilityRole="header"
            className="text-sm font-semibold tracking-widest text-foreground uppercase"
          >
            Composition
          </Text>
          <Text className="text-xs text-muted-foreground">
            Tap a character to explore · Hold to select
          </Text>
        </View>
        <View className="flex-1">
          <DecompositionTreeNode card={readonlySlice} onSelect={handleSelect} />
        </View>
      </View>
    </BottomSheet>
  );
}
